// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"918":"2af34833","3523":"bb0f0b6d","4518":"bb0f0b6d","6403":"bb0f0b6d","7068":"fd76e516"}[chunkId] + ".chunk.css";
};